//@flow
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import Modal from '../../../../../../../elements/Modal/Modal';
import Summary, {SummaryRow, SummaryRule} from '../../../../../../../elements/Summary/Summary';

import full from '../../../../../../../assets/img/new-order/quote-step/Full.png';
import lite from '../../../../../../../assets/img/new-order/quote-step/Lite.png';

import style from './SummaryModal.scss';
import icons from '../../../../../../../assets/styles/icons.scss';

import type {ForecastCourier, ForecastTier} from '../../../../../QuoteStep/api';
import type {ForecastType} from '../ForecastBox/ForecastBox';

type Props = {
  isOpen?: boolean;
  handleClose: () => void;
  forecastClassic?: ForecastTier[];
  forecastCouriers?: ForecastCourier[];
  methodType?: ForecastType;
  fullSubtype?: string;
  liteSubtype?: string;
};

export default function SummaryModal(props: Props) {
  const {isOpen, handleClose, methodType, forecastClassic, forecastCouriers, fullSubtype, liteSubtype} = props;

  let forecastFull = methodType === 'FULL' && forecastClassic ? forecastClassic
    .find((f: ForecastTier) => f.tier.name === fullSubtype) : undefined;

  let forecastLite = methodType === 'LITE' && forecastCouriers ? forecastCouriers
    .find((f: ForecastCourier) => f.courier.id === liteSubtype) : undefined;

  const forecast: ForecastTier | ForecastCourier = (forecastLite: any) || (forecastFull: any);

  // console.log('forecast', forecast);

  return (
    <Modal key="summaryModal"
           open={isOpen}
           width={368}
           height={390}
           gray
           handleClose={() => handleClose()}>
      <div className={style.topWrap}>
        <img src={methodType === 'FULL' ? full : lite} alt="box"/>
        <div className={style.textWrap}>
          <p className={style.title}>
            {methodType === 'FULL' ? 'Qempo Full' : 'Qempo Lite'}
          </p>
          <p className={style.subtitle}>Cotización Detallada</p>
        </div>
      </div>
      <div className={style.contentWrap}>
        {forecastFull &&
        <Fragment>
          <SummaryRow labelIntl="summary.detail.itemTotal"
                      content={`$ ${forecastFull.itemTotal || ''}`}/>
          
          <FormattedMessage id="summary.detail.customsDuties.free">{
            txt => <SummaryRow labelIntl="summary.detail.taxes"
                               color={forecastFull.taxes === '0.00' ? 'green' : undefined}
                               content={forecastFull.taxes === '0.00' ? txt : `$ ${forecastFull.taxes}`}/>
          }</FormattedMessage>
          <SummaryRow labelIntl="summary.detail.shipping"
                      hintIntl="summary.detail.shipping.tooltip"
                      content={`$ ${forecastFull.shipping || ''}`}/>
          <SummaryRule/>
          <SummaryRow labelIntl="summary.detail.subtotal"
                      noTopPadding
                      content={`$ ${forecastFull.subtotal || ''}`}/>
        </Fragment>}
        {forecast && (
          <Fragment>
            <SummaryRow labelIntl="summary.detail.importationFee"
                        hintIntl="summary.detail.importationFee.tooltip"
                        content={`$ ${forecast.importationFee || ''}`}/>
            <SummaryRow labelIntl="summary.detail.qempo"
                        content={`$ ${forecast.qempo || ''}`}/>
            <SummaryRow labelIntl="summary.detail.national"
                        hintIntl="summary.detail.national.tooltip"
                        content={`$ ${forecast.lastMileShipping || ''}`}/>
            {!!forecast.customsDuties && (
              <FormattedMessage id="summary.detail.customsDuties.free">{
                txt => <SummaryRow labelIntl="summary.detail.customsDuties"
                                   color={forecast.customsDuties === '0.00' ? 'green' : undefined}
                                   content={forecast.customsDuties === '0.00' ? txt : `$ ${forecast.customsDuties}`}/>
              }</FormattedMessage>
            )}
            <FormattedMessage id="summary.detail.warranty.free">{
              txt => <SummaryRow labelIntl="summary.detail.warranty"
                                 color="green"
                                 content={txt}/>
            }</FormattedMessage>
            <SummaryRow labelIntl="summary.detail.total"
                        color="black"
                        bold
                        content={`$ ${forecast.total || ''}`}/>
          </Fragment>
        )}
        <div className={style.infoWrap}>
          <i className={icons.symbolCheck}/>
          <span>El total a pagar incluye todos los gastos hasta tus manos.</span>
        </div>
        <div className={style.couponInfoWrap}>
          <span>¿Tienes un cupón de Qempo? Añádelo en el checkout.</span>
        </div>
      </div>
    </Modal>
  );
}

SummaryModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  forecastClassic: PropTypes.array,
  forecastCouriers: PropTypes.array,
  quoteMethodType: PropTypes.string,
  quoteFullSubtype: PropTypes.string,
  quoteLiteSubtype: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/SummaryModal/SummaryModal.jsx